// extracted by mini-css-extract-plugin
export default {"fullWidth":"Go-z","image":"Ho-z","lazyLoadPicture":"Io-z","lazyLoadSpinner":"Jo-z","lazyLoadSpin":"Ko-z","lazyLoadImage":"Lo-z","hasStyledAspectRatio":"Mo-z"};